import { Close, InfoOutlined } from '@mui/icons-material';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { Endorsement } from '@acorn-portal/shared/src/services/api';
import parse from 'html-react-parser';

interface IEndorsements {
	endorsements: Endorsement[];
}

const Endorsements: FC<IEndorsements> = ({ endorsements }) => {
	const [open, setOpen] = useState<string | undefined>();

	if (endorsements?.length === 0) return null;

	return (
		<Box>
			<Typography component='h2' sx={{ fontWeight: 'bold', mb: 1 }}>
				Endorsements
			</Typography>
			<Box sx={{ marginBottom: 4, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
				{endorsements.map((endorsement) => (
					<Box
						key={endorsement.name}
						className='endorsement-chip'
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							borderRadius: 5,
							py: '2px',
							px: 1,
						}}
					>
						<Typography sx={{ fontSize: 14 }}>{endorsement.name}</Typography>
						<Tooltip
							slotProps={{
								popper: {
									disablePortal: true,
									sx: {
										minWidth: { xs: '95vw', md: 'auto' },
										'.MuiTooltip-tooltip': {
											p: 2,
											maxWidth: { xs: '100%', md: '300px' },
											fontSize: { xs: 16, md: 14 },
										},
									},
								},
							}}
							placement='bottom'
							onClose={() => setOpen(undefined)}
							open={open === endorsement.name}
							aria-expanded={open === endorsement.name}
							aria-label={`${endorsement.name} endorsement details`}
							disableHoverListener
							disableTouchListener
							title={
								<Box>
									<Box
										sx={{
											display: 'flex',
											justifyContent: 'end',
										}}
									>
										<Button
											variant='text'
											aria-label='Close'
											sx={{ color: 'white', p: 0, minWidth: 0 }}
											onClick={() => setOpen(undefined)}
										>
											<Close />
										</Button>
									</Box>
									<div>{endorsement.description && parse(endorsement.description)}</div>
								</Box>
							}
						>
							<Button
								variant='text'
								color='secondary'
								sx={{
									p: 0,
									ml: 1,
									minWidth: 0,
									':hover': { backgroundColor: 'transparent' },
								}}
								onClick={() => setOpen(open === endorsement.name ? undefined : endorsement.name)}
							>
								<InfoOutlined color='secondary' />
							</Button>
						</Tooltip>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default Endorsements;
